export default "__VITE_ASSET__DGZSuZwZ__"